import { CognitoUserPool } from 'amazon-cognito-identity-js';

export default (): CognitoUserPool =>
    new CognitoUserPool({
        UserPoolId: process.env.REACT_APP_USER_POOL_ID!,
        ClientId: process.env.REACT_APP_CLIENT_ID!
    });



// WEBPACK FOOTER //
// ./src/application/user/userPool.ts